import React from 'react';
import { GoPerson } from 'react-icons/go';

const UserAvatar = ({ 
  src, 
  alt = 'User', 
  className = 'w-12 h-12 sm:w-16 sm:h-16',
  fallbackClassName = 'w-12 h-12 sm:w-16 sm:h-16'
}) => {
  const [imageError, setImageError] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  if (!src || imageError) {
    return (
      <div className={`${fallbackClassName} rounded-full bg-gray-200 flex items-center justify-center`}>
        <GoPerson className="text-gray-500 text-xl sm:text-2xl" />
      </div>
    );
  }

  return (
    <div className="relative">
      <img
        src={src}
        alt={alt}
        className={`${className} rounded-full object-cover`}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
      {!imageLoaded && !imageError && (
        <div className={`${fallbackClassName} rounded-full bg-gray-200 flex items-center justify-center absolute inset-0`}>
          <GoPerson className="text-gray-500 text-xl sm:text-2xl" />
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
